import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../data/translations';
import './Projects.css';

const Projects = () => {
  const { language } = useLanguage();
  const t = translations[language];

  const projects = [
    {
      title: t.washProject,
      location: t.washLocation,
      target: t.washTarget,
      description: t.washDescription,
      activities: [
        t.washActivity1,
        t.washActivity2,
        t.washActivity3,
        t.washActivity4,
        t.washActivity5
      ],
      impact: t.washImpact,
      images: [
        '/MRRO/Media/portsudan/2.jpg',
        '/MRRO/Media/portsudan/4.jpg',
        '/MRRO/Media/portsudan/6.jpg',
        '/MRRO/Media/portsudan/7.jpg',
        '/MRRO/Media/portsudan/10.jpg',
        '/MRRO/Media/portsudan/11.jpg',
        '/MRRO/Media/portsudan/12.jpg',
        '/MRRO/Media/portsudan/13.jpg',
        '/MRRO/Media/portsudan/14.jpg'
      ],
      projectName: 'Port Sudan'
    },
    {
      title: t.emergencyWaterProject,
      location: t.emergencyLocation,
      target: t.emergencyTarget,
      description: t.emergencyDescription,
      activities: [
        t.emergencyActivity1,
        t.emergencyActivity2,
        t.emergencyActivity3,
        t.emergencyActivity4
      ],
      impact: t.emergencyImpact,
      images: [
        '/MRRO/Media/taweela/1.jpg',
        '/MRRO/Media/taweela/5.jpg',
        '/MRRO/Media/taweela/9.jpg'
      ],
      projectName: 'Taweela - Darfur'
    },
    {
      title: t.eidJoyProject,
      location: t.eidJoyLocation,
      target: t.eidJoyTarget,
      description: t.eidJoyDescription,
      activities: [
        t.eidJoyActivity1,
        t.eidJoyActivity2,
        t.eidJoyActivity3,
        t.eidJoyActivity4
      ],
      impact: t.eidJoyImpact,
      images: [
        '/joy-eid/1.jpeg',
        '/joy-eid/2.jpeg',
        '/joy-eid/3.jpeg',
        '/joy-eid/4.jpeg',
        '/joy-eid/5.jpeg',
        '/joy-eid/6.jpeg',
        '/joy-eid/7.jpeg'
      ],
      projectName: 'Eid Joy Initiative'
    }
  ];

  return (
    <section id="projects" className="section">
      <div className="container">
        <div className="projects-header">
          <h2>{t.projectsFieldExperience}</h2>
          <p>{t.projectsIntro}</p>
        </div>
        
        <div className="projects-grid">
          {projects.map((project, index) => (
            <div key={index} className="project-card">
              <div className="project-header">
                <div className="project-category">{project.projectName}</div>
                <h3>{project.title}</h3>
                <div className="project-meta">
                  <div className="project-location">
                    <span className="location-icon">📍</span>
                    <span>{project.location}</span>
                  </div>
                  <div className="project-target">
                    <strong>{t.targetArea}:</strong> {project.target}
                  </div>
                </div>
              </div>
              
              {/* Project Images Gallery */}
              {project.images && project.images.length > 0 && (
                <div className="project-gallery">
                  <div className="gallery-grid">
                    {project.images.map((image, imgIndex) => (
                      <div key={imgIndex} className="gallery-item">
                        <img src={image} alt={`${project.projectName} - ${imgIndex + 1}`} />
                      </div>
                    ))}
                  </div>
                </div>
              )}
              
              <div className="project-content">
                <p className="project-description">{project.description}</p>
                
                <div className="project-section">
                  <h4>{t.keyActivities}</h4>
                  <ul>
                    {project.activities.map((activity, actIndex) => (
                      <li key={actIndex}>{activity}</li>
                    ))}
                  </ul>
                </div>
                
                <div className="project-section">
                  <h4>{t.impact}</h4>
                  <p>{project.impact}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;